import { render } from "./CardDark.vue?vue&type=template&id=4d5d8e56&scoped=true"
import script from "./CardDark.vue?vue&type=script&lang=js"
export * from "./CardDark.vue?vue&type=script&lang=js"

import "./CardDark.vue?vue&type=style&index=0&id=4d5d8e56&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5d8e56"]])

export default __exports__